import { useQuery } from '@tanstack/react-query';
import { getSubdomain, isValidSubdomain } from '@zealy/utils';
import { tiktokCampaignKeys } from '../tiktokCampaign.keys';
import { getTiktokCampaign } from '../tiktokCampaign.service';
/**
 * Queries a TikTok campaign by its subdomain
 * @param subdomain The subdomain of the community to query, @default subdomain will be inferred from the URL
 * @param enabled Whether the query should be enabled
 * @example const { data, isLoading } = useTiktokCampaign('my-community');
 */
export const useTiktokCampaign = (subdomain, enabled = true) => {
    const domain = subdomain || getSubdomain();
    return useQuery({
        queryKey: tiktokCampaignKeys.tiktokCampaign(domain),
        queryFn: async () => getTiktokCampaign(domain),
        enabled: isValidSubdomain(domain) && enabled,
        retry: 1,
    });
};
